export default __webpack_public_path__ + "22c881faf53ca867bf7825062f939728.png";